export const checkbox = {
  root: {
    borderRadius: "{border.radius.6}",
    width: "18px",
    height: "18px",
    background: "{form.field.background}",
    checkedBackground: "{primary.support}",
    disabledBackground: "{surface.bg.grey.contrast}",
    filledBackground: "{form.field.filled.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.border.color}",
    checkedBorderColor: "{primary.support}",
    checkedHoverBorderColor: "{primary.default}",
    checkedFocusBorderColor: "{primary.default}",
    checkedDisabledBorderColor: "{form.field.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    shadow: "{form.field.shadow}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      width: "12px",
      height: "12px",
    },
    lg: {
      width: "24px",
      height: "24px",
    },
  },
  icon: {
    size: "12px",
    color: "{form.field.color}",
    checkedColor: "{color.white}",
    checkedHoverColor: "{color.white}",
    disabledColor: "{form.field.disabled.color}",
    sm: {
      size: "8px",
    },
    lg: {
      size: "16px",
    },
  },
  colorScheme: {
    light: {
      checkedHoverBackground: "{primary.default}",
    },
    dark: { checkedHoverBackground: "{primary.background}" },
  },
};
